module.exports = __webpack_public_path__ + "media/images/rank_03-621ff8ef5912c0382468315940d30f7e.png";